const modelValidationEn = {
	modelValidationTable: 'Model Validation',
	modelValidationEditForm: 'Model Validation',
	name: 'Name',
	value: 'Value',
	type: 'Type',
	aspect: 'Aspect',
	measurement: 'Measurement',
	modelValidationLog: 'Model Validation Log',
	tolerance: 'Tolerance',
	stateInjectName: 'Name',
	statInjectValue: 'Value',
	whatIf: 'What If',
	userGroup: 'User Group'
};

export default modelValidationEn;